import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Button } from 'semantic-ui-react';
 

function CardCostomosted({ cardData, children }) {
    const navigate = useNavigate();
    const { title, back } = cardData || {};

    return (
        <div className={`'bg-dark-theme-2' : ''}`} style={{ minHeight: '100vh' }}>
            <div className={`card p-3 fixed-top border-0 shadow-sm rounded-0 $ 'bg-dark-theme-1' : ''}`}>
                <div className='row'>
                    <div className='col-2 col-lg-1 align-self-center'>
                        <Button
                            icon
                            size='tiny'
                            className='border-div'
                            onClick={() => navigate('/#/ma')}
                        >
                            <Icon name='arrow left' />
                        </Button>
                    </div>
                    <div className='col-10 col-lg-11 align-self-center'>
                        <h2>
                            <span className="badge" style={{ backgroundColor: 'GConf.themeColor' }}>
                                {title}
                            </span>
                        </h2>
                    </div>
                </div>
            </div>

            {/* spacing to clear the fixed navbar, matches MainTopCard's <br/> stack */}
            <br /><br /><br /><br /> 

            <div className='container-fluid'>
                {children}
            </div>
        </div>
    );
}

export default CardCostomosted;